import { render, staticRenderFns } from "./fnm.vue?vue&type=template&id=5a6ef01f"
import script from "./fnm.vue?vue&type=script&lang=ts"
export * from "./fnm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports